/**
 * 抽取公共方法
 */
import CryptoJS from 'crypto-js'
export default {
  install: function (Vue, options) {
    Vue.mixin({
      data() {
        return {
          myFileUrl: "/api/",
          // 分页信息集合 必须为此格式
          pageInfo: {
            total: 0, // 总数量
            pageNum: 1, // 当前第几页
            pageSize: 16, // 当前页数量条数
          },
          // 文库
          pageInfo4: {
            total: 0, // 总数量
            pageNum: 1, // 当前第几页
            pageSize: 12, // 当前页数量条数
          },
          pageInfo2: {
            total: 0, // 总数量
            pageNum: 1, // 当前第几页
            pageSize: 10, // 当前页数量条数
          },
          pageInfo3: {
            total: 0, // 总数量
            pageNum: 1, // 当前第几页
            pageSize: 8, // 当前页数量条数
          },
          commentPageInfo: {
            total: 0, // 总数量
            pageNum: 1, // 当前第几页
            pageSize: 3, // 当前页数量条数
          },
          pageInfo1: {
            total: 0, // 总数量
            pageNum: 1, // 当前第几页
            pageSize: 2, // 当前页数量条数
          },
          isShare: false,//分享图标是否显示
          shuXueList: [],//腧穴列表
          // 数据字典开始
          effectList: [], //药品功效
          yaoxingList: [], //药性
          yaoweiList: [], //药味
          guijingList: [], //归经
          yaobuweiList: [], //药用部位
          zcList: [],//职称
          sclyList: [],//擅长领域
          // 数据字典结束
          adverWordsTip: "广告",
          adverA: "",//首页广告位置a图片路径
          adverAurl: "",//首页广告位置a图片url
          adverB: "",
          adverBurl: "",
          jingtangAdverList: [],//讲堂广告列表
          wenkuAdverList: [],//文库广告列表
          zhongcaoyaoAdverList: [],//中草药广告列表
          jingxueAdverList: [],//经络穴位广告列表
          isCollection: false,//没有收藏
          commentList: [],//查询评论的数组
          commentTotal: "0",//评论条数
          isYS: false,//不是医师
          userInfo: {},
          GRSList: [], //个人史
          JZSList: [], //家族史
          JWSList: [], //既往史
          YWGMSList: [], //药物过敏史
          educationLevelList: [], //教育程度
          occupationList: [], //职业
          nationList: [],//民族
          YAList: [],//医案类型
          departmentList:[],//科室
          examineList:[],//检查项
          searchList: [], //结果列表
          partList:[],//身体部位
          seachInput: "" ,//搜索内容
          //分享配置
          config1: {
            url: window.location.href, // 网址，默认使用 window.location.href
            // source: "", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
            // title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
            // description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
            // image: "", // 图片, 默认取网页中第一个img标签
            sites: ["qzone", "qq", "weibo", "wechat"], // 启用的站点
            // disabled: [], // 禁用的站点
            wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
            wechatQrcodeHelper:
              "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享给朋友。</p>"
          },

          dialogFormVisibleYJFK: false,//需要登陆的弹框才能进行的操作
          countDownList: '00天00时00分00秒',//倒计时间
        };
      },
      computed: {
        activeIndexJ(){
          return  this.$route.path || '';  
           
        } 
      },

      mounted() {
        let aaa = document.referrer
      },
      methods: {
        // shareF() {
        //   this.isShare = !this.isShare;
        // },
          decrypt(data, SECRET_KEY) { //密钥//SECRET_KEY:6TuKlX4mwNflf95I
              const key = CryptoJS.enc.Utf8.parse(SECRET_KEY); // 密钥，16位
              const decrypted = CryptoJS.AES.decrypt(data, key, {
                  mode: CryptoJS.mode.ECB,
                  padding: CryptoJS.pad.Pkcs7
              });
              return decrypted.toString(CryptoJS.enc.Utf8);
          },
          //AES加密
          encrypt(data, SECRET_KEY) { //AES加密
              const key = CryptoJS.enc.Utf8.parse(SECRET_KEY); // 密钥，16位
              const encrypted = CryptoJS.AES.encrypt(data, key, {
                  mode: CryptoJS.mode.ECB,
                  padding: CryptoJS.pad.Pkcs7
              });
              return encrypted.toString();
          },
        timeFormat2(param) {
          return param < 10 ? '0' + param : param;
        },
        countDown(actEndTime) {//倒计时函数
          var interval = setInterval(() => {
            // 获取当前时间，同时得到活动结束时间数组
            let newTime = Math.round(new Date().getTime() / 1000);
            // 对结束时间进行处理渲染到页面
            let endTime = new Date(actEndTime).getTime();
            let obj = null;
            // 如果活动未结束，对时间进行处理
            if (endTime - newTime > 0) {
              let time = (endTime - newTime);
              // 获取天、时、分、秒
              let day = parseInt(time / (60 * 60 * 24));
              let hou = parseInt(time % (60 * 60 * 24) / 3600);
              let min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
              let sec = parseInt(time % (60 * 60 * 24) % 3600 % 60);
              obj = {
                day: this.timeFormat2(day),
                hou: this.timeFormat2(hou),
                min: this.timeFormat2(min),
                sec: this.timeFormat2(sec)
              };
            } else { // 活动已结束，全部设置为'00'
              obj = {
                day: '00',
                hou: '00',
                min: '00',
                sec: '00'
              };
              clearInterval(interval);
            }

            this.countDownList = obj.day + '天' + obj.hou + '时' + obj.min + '分' + obj.sec + '秒';
          }, 1000);
        },
        // 时间格式转换函数
        //将"2018-05-19T08:04:52.000+0000"这种格式的时间转化为正常格式
        getTime(time) {
          var clock = "";
          if (time) {
            var d = new Date(time);
            var year = d.getFullYear(); //年
            var month = d.getMonth() + 1; //月
            var day = d.getDate(); //日

            var hh = d.getHours(); //时
            var mm = d.getMinutes(); //分
            var ss = d.getSeconds(); //秒
            clock = year + "-";

            if (month < 10) clock += "0";

            clock += month + "-";

            if (day < 10) clock += "0";

            clock += day + " ";
            if (hh < 10) clock += "0";

            clock += hh + ":";
            if (mm < 10) clock += "0";
            clock += mm + ":";

            if (ss < 10) clock += "0";
            clock += ss;
          }
          return clock;
        },
        //时间戳转成date格式
        getdate(str) {
          if (str) {
            var now = new Date(str),
              y = now.getFullYear(),
              m = now.getMonth() + 1,
              d = now.getDate();
            return (
              y +
              "-" +
              (m < 10 ? "0" + m : m) +
              "-" +
              (d < 10 ? "0" + d : d) +
              " " +
              now.toTimeString().substr(0, 8)
            );
          }
        },
        //转成时间戳
        changeChuo(date) {
          date = date.substring(0, 19);
          date = date.replace(/-/g, "/");
          var timestamp = new Date(date).getTime();
          return timestamp;
        },
        //获取位置广告,
        // a为广告位置,0:首页a  1:首页b   2讲堂 3文库  4中草药  5经络穴位
        // b为广告类型,3广告列表(6个位置,首页两个,讲堂,文库,中草药,经络穴位)
        getPositionAdver(a, b) {
          let that = this;
          let url = "/news/getByAdvseat";
          let params = {
            advSeat: a,
            seatId: b,
          }
          that.$http.post(url, params).then(res => {
            if (res.data.code == 200) {
              let arr = res.data.data;
              if (a == 0 && !!arr) {
                //首页位置A
                that.adverA = arr.urlImage;
                that.adverAurl = arr.urlLink;
              }
              if (a == 1 && !!arr) {
                //首页位置B
                that.adverB = arr.urlImage;
                that.adverBurl = arr.urlLink;
              }
              if (a == 2 && !!arr) {
                //讲堂
                that.jingtangAdverList = arr.map(
                  (item, index) => {
                    return {
                      urlImage: item.urlImage,
                      urlLink: item.urlLink,
                    };
                  }
                );
              }
              if (a == 3 && !!arr) {
                //文库
                that.wenkuAdverList = arr.map(
                  (item, index) => {
                    return {
                      urlImage: item.urlImage,
                      urlLink: item.urlLink,
                    };
                  }
                );
              }
              if (a == 4 && !!arr) {
                //中草药
                that.zhongcaoyaoAdverList = arr.map(
                  (item, index) => {
                    return {
                      urlImage: item.urlImage,
                      urlLink: item.urlLink,
                    };
                  }
                );
              }
              if (a == 5 && !!arr) {
                //经络穴位
                that.jingxueAdverList = arr.map(
                  (item, index) => {
                    return {
                      urlImage: item.urlImage,
                      urlLink: item.urlLink,
                    };
                  }
                );
              }
            } else {
              that.$message.error(res.message);
            }
          })
            .catch(() => {
              that.$message.error("网络错误！");
            });
        },
        // 获取广告详情
        getAdverDetail(id) {
          let that = this;
          let url = "/news/get";
          let params = {
            id: id,
          }
          that.$http.post(url, params).then(res => {
            if (res.data.code == 200) {
              // let arr = res.data.data;

            } else {
              that.$message.error(res.message);
            }
          })
            .catch(() => {
              that.$message.error("网络错误！");
            });
        },
        //获取腧穴列表
        getShuxueList() {
          let that = this;
          let url = "/jlxw/sxdwf/list";
          that.$http
            .post(url)
            .then(res => {
              if (res.data.code == 200) {
                that.shuXueList = res.data.data
              } else {
                that.$message.error(res.message);
              }
            })
            .catch(() => {
              that.$message.error("网络错误！");
            });
        },
        //显示多少个字
        limitMaxWords(max, words) {
         // 如果传入的 words 为空，则直接返回
          if (!words) return;
          // 定义匹配 HTML 标签的正则表达式
          const htmlRegex = /<[^>]*>/g;
          // 去除 HTML 标签
          let word = words.replace(htmlRegex, '');
          // 定义匹配普通空格和 &nbsp; 的正则表达式
          const spaceRegex = /\s|&nbsp;/gi;
          // 去除普通空格和 &nbsp;
          word = word.replace(spaceRegex, '');
          // 判断处理后的字符串长度是否超过最大限制
          if (word.length > max) {
              // 若超过最大限制，截取前 max - 1 个字符并添加省略号
              return word.substring(0, max - 1) + '...';
          } else {
              // 若未超过最大限制，直接返回处理后的字符串
              return word;
          }
        },
        // 去讲堂详情
        jiangtangV(type, id) {
          let that = this;
          if (type == "0") {
            // 视频类
            that.$router.push({
              path: "/ForumDetailv",
              query: { type: type, id: id }
            });
          } else {
            // 文章类
            that.$router.push({
              path: "/ForumDetailw",
              query: { type: type, id: id }
            });
          }
        },
        // 数据字典
        async dataDictionary(type) {
          let that = this;
          let params = {
            sysDictType: type
          };
          await that.$http.post("/common/findSysDictList", params).then(res => {
            if (res.data.code == 200) {
              let list = res.data.data;
              if (type == "medicine") {
                // 药性
                that.yaoxingList = [];
                that.yaoxingList.push({
                  id: "",
                  name: "不限",
                  checked: true
                });
                for (let i = 0; i < list.length; i++) {
                  that.yaoxingList.push({
                    id: list[i].id,
                    name: list[i].lableTwo,
                    checked: false
                  });
                }
              } else if (type == "pill") {
                // 药味
                that.yaoweiList = [];
                that.yaoweiList.push({
                  id: "",
                  name: "不限",
                  checked: true
                });
                for (let i = 0; i < list.length; i++) {
                  that.yaoweiList.push({
                    id: list[i].id,
                    name: list[i].lableTwo,
                    checked: false
                  });
                }
              } else if (type == "channelTropism") {
                // 归经
                that.guijingList = [];
                that.guijingList.push({
                  id: "",
                  name: "不限",
                  checked: true
                });
                for (let i = 0; i < list.length; i++) {
                  that.guijingList.push({
                    id: list[i].id,
                    name: list[i].lableTwo,
                    checked: false
                  });
                }
              } else if (type == "medicinalPart") {
                // 药用部位
                that.yaobuweiList = [];
                that.yaobuweiList.push({
                  id: "",
                  name: "不限",
                  checked: true
                });
                for (let i = 0; i < list.length; i++) {
                  that.yaobuweiList.push({
                    id: list[i].id,
                    name: list[i].lableTwo,
                    checked: false
                  });
                }
              } else if (type == "efficacyDrugsDescribe") {
                // 药品功效
                that.effectList = [];
                that.effectList.push({
                  id: "",
                  name: "不限",
                  checked: true
                });
                for (let i = 0; i < list.length; i++) {
                  that.effectList.push({
                    id: list[i].id,
                    name: list[i].lableTwo,
                    checked: false
                  });
                }
              } else if (type == "ZC") {
                // 职称
                that.zcList = [];
                that.zcList = list;
              } else if (type == "SCLY") {
                // 职称
                that.sclyList = [];
                that.sclyList = list;
              } else if (type == "GRS") {
                //个人史
                that.GRSList = [];
                for (const item of list) item.check = false;
                this.GRSList = list;
                this.GRSList.push({
                  check: false,
                  id: "",
                  lableTwo: "",
                  custom: true
                });
              } else if (type == "JZS") {
                //家族史
                that.JZSList = [];
                for (const item of list) item.check = false;
                this.JZSList = list;
                this.JZSList.push({
                  check: false,
                  id: "",
                  lableTwo: "",
                  custom: true
                });
              } else if (type == "JWS") {
                //既往史
                that.JWSList = [];
                for (const item of list) item.check = false;
                this.JWSList = list;
                this.JWSList.push({
                  check: false,
                  id: "",
                  lableTwo: "",
                  custom: true
                });
              } else if (type == "YWGMS") {
                //药物过敏史
                that.YWGMSList = [];
                for (const item of list) item.check = false;
                this.YWGMSList = list;
                this.YWGMSList.push({
                  check: false,
                  id: "",
                  lableTwo: "",
                  custom: true
                });
              } else if (type == "JYCD") {
                //教育程度
                return (that.educationLevelList = list.map((item, index) => {
                  return {
                    label: item.lableTwo,
                    value: item.lableTwo
                  };
                }));
              } else if (type == "ZY") {
                //职业
                return (that.occupationList = list.map((item, index) => {
                  return {
                    label: item.lableTwo,
                    value: item.lableTwo
                  };
                }));
              } else if (type == "MZ") {
                //民族
                return (that.nationList = list.map((item, index) => {
                  return {
                    label: item.lableTwo,
                    value: item.lableTwo
                  };
                }));
              } else if (type == "YALX") {
                //医案类型
                return (that.YAList = list.map((item, index) => {
                  return {
                    label: item.lableTwo,
                    value: item.lableTwo
                  };
                }));
              }else if (type == "department") {
                //科室
                return (that.departmentList = list.map((item, index) => {
                  return {
                    label: item.lableTwo,
                    value: item.value-0
                  };
                }));
              }else if (type == "examine") {
                //检查项
                return (that.examineList = list.map((item, index) => {
                  return {
                    label: item.lableTwo,
                    value: item.value-0
                  };
                }));
              }else if (type == "part") {
                //检查项
                return (that.partList = list.map((item, index) => {
                  return {
                    label: item.lableTwo,
                    value: item.value-0
                  };
                }));
              }
            }
          });
        },
        // 收藏
        // 1:草药 2：商品 3：视频 4：文库 5：经络 6：穴位
        collect(id, type) {
          let that = this;
          if (!that.isLoginF()) return false
          let url = "/common/collection";
          let parmas = {
            id: id,
            type: type
          };
          that.$http
            .post(url, parmas)
            .then(res => {
              if (res.data.code == 200) {
                that.isCollection = true;
                that.$message({
                  message: '收藏成功',
                  type: 'success'
                });
              } else {
                that.$message.error(res.data.msg);
              }
            })
            .catch(() => {
              that.$message.error("网络错误！");
            });
        },
        // 取消收藏
        // 1:草药 2：商品 3：视频 4：文库 5：经络 6：穴位
        unCollect(id, type) {
          let that = this;
          if (!that.isLoginF()) return false
          let url = "/common/unCollection";
          let parmas = {
            id: id,
            type: type
          };
          that.$http
            .post(url, parmas)
            .then(res => {
              if (res.data.code == 200) {
                that.isCollection = false;
                that.$message({
                  message: '已取消收藏',
                  type: 'success'
                });
              } else {
                that.$message.error(res.data.msg);
              }
            })
            .catch(() => {
              that.$message.error("网络错误！");
            });
        },
        //获取所有评论
        //forumId:讲堂编号
        async getAllComment(forumId) {
          let that = this;
          if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
          }
          let url = "/medicineForum/getList";
          let parmas = {
            forumId: forumId,
            userId: that.userInfo.id,
            pageNum: that.commentPageInfo.pageNum,
            pageSize: that.commentPageInfo.pageSize,
          };
          await that.$http
            .post(url, parmas)
            .then(res => {
              if (res.data.code == 200) {
                let arr = res.data.data;
                let commentList1 = [];
                if (arr.list.length == 0 && that.commentPageInfo.pageNum > 1) {
                  this.$message({
                    message: '没有更多评论了！',
                    type: 'success'
                  });
                }
                that.commentTotal = arr.total;
                commentList1 = arr.list.map((item, index) => {
                  return {
                    id: item.id,
                    headImg: item.headImg,
                    createDate: that.getTime(item.createDate),
                    commentText: item.commentText,
                    username: item.username,
                    commentRever: false,
                  };
                });
                //将得到的数据合并到上一次的数组中
                that.commentList = that.commentList.concat(commentList1)
              } else {
                that.$message.error(res.data.msg);
              }
            })
            .catch(() => {
              that.$message.error("网络错误！");
            });
        },
        // 添加评论
        //讲堂编号,讲堂名称,评论内容
        async addComment(forumId, forumName, commentText) {
          let that = this;

          if (!that.isLoginF()) return false
          this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
          let url = "/medicineForum/saveComment";
          let parmas = {
            forumId: forumId,
            userId: that.userInfo.id,
            forumName: forumName,
            commentText: commentText,
          };
          await that.$http
            .post(url, parmas)
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "发布评论成功"
                });
              } else {
                that.$message.error(res.data.msg);
              }
            })
            .catch(() => {
              that.$message.error("网络错误！");
            });


        },
        // 是否是医师
        isYF(a) {
          if (!a) return
          if (a == '0') {
            return '是'
          }
          if (a == '1') {
            return '否'
          }

        },
        //阿拉伯数字转换成汉字
        toChinesNum(num) {
          if(num===null || num===undefined) return '0' // 张志岭 添加为空校验
          let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
          let unit = ["", "十", "百", "千", "万"];
          num = parseInt(num);
          let getWan = (temp) => {
            let strArr = temp.toString().split("").reverse();
            let newNum = "";
            for (var i = 0; i < strArr.length; i++) {
              newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
            }
            return newNum;
          }
          let overWan = Math.floor(num / 10000);
          let noWan = num % 10000;
          if (noWan.toString().length < 4) noWan = "0" + noWan;
          return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
        },
        // 必须为数字
        numPanDuan(a) {
          let that = this;
          let numberReg = /^[0-9]+$/;
          if (!!a && !numberReg.test(a)) {
            return false
          } else {
            return a
          }
        },
        //获取编号
        getNumber(type) {
          let that = this;
          let params = {
            type: type
          };
          return that.$http.post("/serialNumber/getId", params).then(res => {
            return (that.addNumber = res.data);
          });
        },
        //计算距离现在的年数
        yearsCal(a) {
          var myDate = new Date();
          var tYear = myDate.getFullYear();
          return tYear - a
        },
        //选择时间不能大于当前时间
        beginDate() {
          return {
            disabledDate(time) {
              return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
            }
          }
        },
        //个人史
        ges(medication) {
          let str = "";
          if (medication && medication.length) {
            for (let i = 0; i < medication.length; i++) {
              if (medication[i]) {
                if (i === medication.length - 1)
                  str +=
                    medication[i].personalHistory +
                   '，' + medication[i].years +
                    "年";
                else
                  str += `${medication[i].personalHistory + '，' +
                    medication[i].years +
                    "年"}; `;
              }
            }
          }
          return str;
        },
        //既往史,药物过敏史
        jwyws(medication, b) {
          let str = "";
          if (medication && medication.length) {
            for (let i = 0; i < medication.length; i++) {
              if (medication[i]) {
                if (i === medication.length - 1)
                  str += medication[i][b];
                else str += `${medication[i][b]};`;
              }
            }
          }
          return str;
        },
        //家族史
        jzs(medication) {
          let str = "";
          if (medication && medication.length) {
            for (let i = 0; i < medication.length; i++) {
              if (medication[i]) {
                if (i === medication.length - 1)
                  str +=
                    medication[i].illness +
                    "(" +
                    medication[i].familyMember +
                    ")";
                else
                  str += `${medication[i].illness +
                    "(" +
                    medication[i].familyMember +
                    ")"};`;
              }
            }
          }
          return str;
        },
        //分享
        shareF() {
          let that = this;
          if (!that.isLoginF()) return false
          this.isShare = !this.isShare;
        },
        //修改密码保存
        submitDialog(form) {
          let that = this;
          this.$refs.form.validate(async valid => {
            if (!valid) return;
            let url = "/user/modifyPassword";
            let params = {
              password: that.dialogData.form.oldpassword,
              temp: that.dialogData.form.newpassword
            };
            that.$http
              .post(url, params)
              .then(res => {
                if (res.data.code == 200) {
                  sessionStorage.clear();
                  that.dialogData.dialogFormVisible = false;
                  that.login = true;
                  that.$router.replace({
                    path: "/login"
                  });
                } else {
                  that.$message.error(res.data.msg);
                }
              })
              .catch(() => {
                that.$message.error("网络错误！");
              });
          });
        },
        // 用户服务协议
        getUser() {
          let that = this;
          that.centerDialogVisible = true;
          let url = "userAgr/getByflag";
          that.$http
            .post(url)
            .then(res => {
              res = res.data;
              if (res.code == 200) {
                that.title = "用户服务协议";
                that.content = res.data.content;
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(() => {
            });
        },
        //隐私策略
        getYiSi() {
          let that = this;
          that.centerDialogVisible = true;
          let url = "privacy/getByflag";
          that.$http
            .post(url)
            .then(res => {
              res = res.data;
              if (res.code == 200) {
                that.title = "隐私策略";
                that.content = res.data.content;
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(() => {
            });
        },

        // 获取url参数
        getUrlKey(name) {
          return (
            decodeURIComponent(
              (new RegExp(
                "[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)"
              ).exec(location.href) || [, ""])[1].replace(/\+/g, "%20")
            ) || null
          );
        },
        //判断是否登陆了，记录登录前页面
        isLoginF() {
          if (!sessionStorage.getItem("userInfo")) {
            this.$confirm('您还未登陆，是否登录?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              localStorage.setItem("loginBeforeUrl", window.location.href);
              this.dialogFormVisibleYJFK = false;
              this.$router.replace({ path: "/login" });
              return false
            }).catch(() => {
              return true
            });
          } else {
            return true
          }
        },
        //强制跳到登录页
        jumpLogin() {
          if (!sessionStorage.getItem("userInfo")) {
            this.$router.replace({ path: "/login" });
            return false
          } else {
            return true
          }
        },
        //多少秒后重新获取验证码
        timeryzm() {
          if (this.time > 0) {
            this.time--;
            // console.log(this.time);
            this.btntxt = this.time + "s";
            setTimeout(this.timeryzm, 1000);
          } else {
            this.time = 60;
            this.btntxt = "重新获取";
            this.disabledyzm = false;
          }
        },
        //医师审批状态显示
        ysSpStatus(a) {
          if (a == '1') {
            return '审批通过'
          } else if (a == '0') {
            return '审批中'
          } else {
            return '审批驳回'
          }

        },
        //获取用户信息
        getUserinfo() {
          if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            if (this.userInfo.id) {
              this.login = false;
            } else {
              this.login = true;
            }
          }
        },
        //立即诊断
        zizhen() {
          if (!this.isLoginF()) return false;
          this.userInfo = JSON.parse(sessionStorage.getItem("userInfo")); 
          if(this.userInfo.userType == 2){
            this.$router.push({
              path: "/myPatientsT"
            });
          }else {
            this.$router.push({
              path: "/myYiAn", query: { yian: true }
            });
          } 
        },
        /* 精确计算两数的积  算钱用
    * @method subtraction
    * @param {Number} v1 有效数值1 
    * @param {Number} v2 有效数值2 
    * @return {Number} 两数值的乘积
    */
        multiplication(v1, v2) {
          var m = 0;
          var s1 = v1.toString();
          var s2 = v2.toString();
          //获取两数的浮点位数
          try { m += s1.split(".")[1].length } catch (e) { }
          try { m += s2.split(".")[1].length } catch (e) { }
          //去除小数点的两数相乘，除以（10为底数，两值浮点位数的次幂）
          return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
        },
        // 得到结果列表
        getResult(content) {
          let that = this;
          let url = "/esSearchPc/esSearch";
          let params = {
            content: content,
            pageSize: that.pageInfo2.pageSize,
            pageNum: that.pageInfo2.pageNum
          };
          that.$http
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                that.searchList = [];
                that.pageInfo2.total = res.data.data.total;
                that.pageInfo2.pageSize = res.data.data.pageSize;
                that.searchList = res.data.data.lists;
              } else {
                that.$message(res.data.msg);
              }
            })
            .catch(() => {
              that.$message("网络错误！");
            });
        },
      },
      created() { }
    });
  }
};



// WEBPACK FOOTER //
// ./src/common/common.js